import { useMemo } from 'react';
import type { CMSGroupParams } from '@/api/cms/base';
import { groupsExclude, groupsInclude, schedule } from '@/helpers/cms';
import { useGetCommonStore } from '@/store/commonStore';

export const useMatchingSections = <T extends CMSGroupParams>(
  sections: T[],
  bypassInclude?: (section: T) => boolean
) => {
  const useCommonStore = useGetCommonStore();
  const user = useCommonStore.use.user();
  const isAuthenticated = useCommonStore.use.isAuthenticated();

  const section = useMemo(
    () =>
      sections.filter((section) => {
        if (!isAuthenticated && section.showGuestToggle !== undefined) {
          return section.showGuestToggle === true;
        }

        const matchesInclude =
          groupsInclude(user)(section) || !!bypassInclude?.(section);

        if (
          section.durationFrom !== undefined &&
          section.durationTo !== undefined
        ) {
          return (
            schedule(section) && matchesInclude && groupsExclude(user)(section)
          );
        }

        return matchesInclude && groupsExclude(user)(section);
      }),
    [sections, user, isAuthenticated, bypassInclude]
  );

  return section;
};
